export default {
    pageMainContainer: {
        padding: 1,
        width: "100%",
        height: "100%"
    },
    tabPanel: {
        width: "inherit",
        height: "85%",
        "& div": {
            width: "inherit",
            height: "100%",
            "& iframe": {
                border: "none"
            }
        }
    },
    mainHeaderContainer: {
        mx: 2,
        my: 4,
        "& h6": {
            verticalAlign: "middle"
        },
        "& > *": { display: "inline-block" }
    }
};
